module.exports = __webpack_public_path__ + "img/17.975fe135.jpg";